//DSS Documentation on Angular Components - http://tiny.sc/cgangularcomponent
import { Component, EventEmitter, OnInit, AfterViewInit, Input, Output, Pipe, PipeTransform, HostListener } from '@angular/core';
import { NgModule } from '@angular/core';
//import { ViewChild, ElementRef } from '@angular/core';
import { SocoModalService } from '@soco/modal';
import { SocoHttpService } from '@soco/http';
//import { AppBaseService } from './app-base.service';
import { DBTraceLogService } from '../../services/dbTraceLog/dbTraceLog.service';
import { DBTraceLog, LogType } from '../../services/dbTraceLog/dbTraceLog-entities';
import { CoolEmailService } from '../../services/coolEmail/coolEmail.service';
import { CoolEmailSettings } from '../../services/coolEmail/coolEmail-entities';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'app-base',
    template: '',
    providers: [DBTraceLogService, CoolEmailService, DeviceDetectorService]
})
export class AppBaseComponent implements OnInit {

    //#region Variables
           
    public coolEmailSettings: CoolEmailSettings;
    //public deviceInfo = null;       
    //public appConfigurationDataList: Array<AppConfigurationData> = []; 

    //#endregion

    constructor(public http: SocoHttpService,
        public dbTraceLogService: DBTraceLogService,
        public coolEmailService: CoolEmailService,
        public deviceService: DeviceDetectorService) {

        //Get Device Info on base comp, so that all extended components has this info.
        //this.deviceInfo = this.deviceService.getDeviceInfo();

    };

    ngOnInit() {

    }

    //public GetApplicationConfigsThruBase() {
    ////public GetApplicationConfigsThruBase(): Array<AppConfigurationData> {
    ////public GetApplicationConfigsThruBase(): Observable<any> {

    //    //var appConfigurationDataList: Array<AppConfigurationData> = [];

    //    this.appBaseService.getApplicationConfigs().subscribe(ApiResult => {

    //        if (ApiResult.data != null) {

    //            ApiResult.data.forEach(configData => {
    //                this.appConfigurationDataList.push(configData);
    //            });
    //        }

    //    });

    //    //return this.appConfigurationDataList;
    //    //return of(this.appConfigurationDataList);
    //}

    public InsertDBTraceLogThruBase(dbTraceLog: DBTraceLog) {

        var deviceInfo = this.deviceService.getDeviceInfo();

        if (deviceInfo != null) {
            dbTraceLog.deviceOS = deviceInfo.os + '_' + deviceInfo.os_version;
            dbTraceLog.deviceBrowser = deviceInfo.browser + '_' + deviceInfo.browser_version;
        }
        dbTraceLog.deviceType = this.getDeviceType();

        this.dbTraceLogService.insertDBLog(dbTraceLog).subscribe(ApiResult => {
            if (ApiResult != null && ApiResult.statusCode == 200) {
                //console.log('Log Inserted Successfully');                
            }
            else {
                console.log('Log insert failed');
            }

            //Trigger email when logType is Error
            if (dbTraceLog.logType.toUpperCase() === "ERROR") {
                this.sendEmail(dbTraceLog);
            }
        });
    }

    

    //#region Send Cool Email

    private sendEmail(dbTraceLog: DBTraceLog) {

        this.coolEmailSettings = new CoolEmailSettings();

        this.coolEmailSettings.body = this.constructEmailBody(dbTraceLog);
        this.coolEmailSettings.subject = 'KMI Error - ' + this.getKMIPortalType(dbTraceLog.portalTypeID);
        this.coolEmailSettings.to = dbTraceLog.emailToList;

        this.coolEmailService.sendEmail(this.coolEmailSettings).subscribe(ApiResult => {
            if (ApiResult != null && ApiResult.statusCode == 200) {
                //console.log(`SendEmail ApiResult: ${ApiResult}`);
            }
            else
                console.log('Error occured while sending email');
        });
    }

    private constructEmailBody(dbTraceLog: DBTraceLog): string {
        var emailBody = '';

        emailBody = `<html> 
                        <style>
                            table, td {
                              border: 1px solid black;
                            }
                        </style>
                        <span> Error Occured in <b> KMI ${this.getKMIPortalType(dbTraceLog.portalTypeID)} </b> with following details </span> <br/><br/>
                        <table style='width:95%'>
                            <tr>
                                <td style='width:25%'>LDC</td>
                                <td style='width:65%'> ${this.isBlank(dbTraceLog.ldc)} </td>
                            </tr>
                            <tr>
                                <td style='width:25%'>Order Number</td>
                                <td style='width:65%'> ${this.isBlank(dbTraceLog.issuingApOrderID)}</td>
                            </tr>
                            <tr>
                                <td style='width:25%'>Order Type </td>
                                <td style='width:65%'> ${this.isBlank(dbTraceLog.orderType)}</td>
                            </tr>
                            <tr>
                                <td style='width:25%'> URL Code </td>
                                <td style='width:65%'> ${this.isBlank(dbTraceLog.kmiUrlCode)} </td>
                            </tr>
                            <tr>
                                <td style='width:25%'>Log Message</td>
                                <td style='width:65%'> ${this.isBlank(dbTraceLog.logMessage)}</td>
                            </tr>
                            <tr>
                                <td style='width:25%'> Log Ref ID</td>
                                <td style='width:65%'> ${this.isBlank(dbTraceLog.logReferenceID)}</td>
                            </tr>
                        </table> <br/>
                        <span> Please check for more details in KMIPortalLogs using above Order Number or Log Reference ID</span>
                    </html>`;


        return emailBody;
    }

    private getKMIPortalType(portalTypeID: Number): string {

        var res: string = '';

        switch (portalTypeID) {
            case 1: { res = 'Customer Portal'; break; }
            case 2: { res = 'Rescheduling Portal'; break; }
            case 3: { res = 'Scheduling Portal'; break; }

            default: { res = 'KMI Error'; break; }
        }

        return res;
    }

    private isBlank(str): string {
        if (str === null || str.length === 0 || !str)
            return 'NA'
        else
            return str;
    }

    //#endregion
    //#region Device Info

    public getDeviceType(): any {

        var deviceType = 'Undefined';

        if (this.deviceService != null) {
            if (this.deviceService.isMobile())
                deviceType = 'Mobile';
            else if (this.deviceService.isDesktop())
                deviceType = 'Desktop';
            else if (this.deviceService.isTablet())
                deviceType = 'Tablet';
            else
                deviceType = 'Undefined';
        }

        return deviceType;
    }

    //#endregion

}
